import { DtoForceConstructor } from '@core/utils/dto';
import { MapMarker } from '../map/map-marker';
import { Moment } from 'moment';
import { DeliveryOrderEventType } from './delivery-order-event-type';
import { DeliveryOrderEventStatus } from './delivery-order-event-status';
import { LatLng } from '../map/lat-lng';
import { ICON_MARKER_BLACK, ICON_MARKER_RED } from '@components/map/map-marker';

@DtoForceConstructor
export class DeliveryOrderEvent implements MapMarker {
    public id: string;
    public createdAt: Moment;
    public type: DeliveryOrderEventType;
    public status: DeliveryOrderEventStatus;
    public tooltip: string;
    public latLng: LatLng;
    public title: string;
    public subtitle: string;
    public header: string;
    public time: string;
    public isLastEvent?: boolean;

    constructor(value?: {
        type: DeliveryOrderEventType;
        status: DeliveryOrderEventStatus;
        createdAt?: Moment;
        latLng?: LatLng;
        title?: string;
        subtitle?: string;
    }) {
        if (value) {
            this.type = value.type;
            this.status = value.status;
            this.createdAt = value.createdAt;
            this.latLng = value.latLng;
            this.title = value.title;
            this.subtitle = value.subtitle;

            this.id = value.type;
            this.tooltip = value.type;
        }
    }

    get iconMarkerUrl(): string {
        let url: string;
        if (this.type === DeliveryOrderEventType.PICKUP) {
            url = ICON_MARKER_BLACK;
        } else {
            url = ICON_MARKER_RED;
        }

        return url;
    }
}
